export default {
  BANK_REMOVED: 'BANK_REMOVED',
  NEW_BANK_LINKED: 'NEW_BANK_LINKED',
  NEW_ACCOUNT_ADDED: 'NEW_ACCOUNT_ADDED',
};
